

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "scene-type-component",
})
export default class SceneTypeComponent extends Vue {
  @Prop(String) name;
  @Prop(Number) webinarNumber;
  @Prop(Number) meetingNumber;
  @Prop(Number) normalNumber;
  @Prop(String) image;
}
